import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		// 声明以及赋初始值
		bgcolor: '#4DC2E6',//f87e4e
		leftWidth: 150,			//左侧导航栏宽度
		htmlWidth: 1600,			//左侧导航栏宽度
		htmlheight: 800,			//左侧导航栏宽度
		isfirst: false,			//左侧导航栏宽度
		tableDataTop: [], 		// 单头部分 生成的行数 数据结构
		tableColumnTop: [],		// 单头部分 生成的列数 数据结构

		bodyGeneralDesign: {},	// 单体总体设计

		bodyTableColumn: [],		// 单体部分 生成的列数  数据结构
		bodyTableData: [],		// 单体部分 表格数据 数据结构
		bodyTableColumnAll: [],		// 单体部分 生成的列数  数据结构
		bodyTableDataAll: [],		// 单体部分 表格数据 数据结构

		chadanfartherData: {},			// 整单体数据对象


		chadanArr: [],		// 查单的单头数据
		chadanObj: {},		// 查单的单头 总体设计数据

		chadanArrTwo: [],	//查单单体数据
		chadanObjTwo: {},	// 查单的单体 总体设计数据
		naviid: 0,			// home的导航id
		peizhiType: '',		// 配置的类型
		peizhiNaviid: 0,		// 配置的导航id
		peizhiName: '',		//
		naviname: '',
		peizhiNav: "",
		historyBB: [], // 历史打开的报表
	},
	mutations: {  // 修改state
		//这里是set方法
		setLeftWidth(state, data) {
			state.leftWidth = data
		},
		sethtmlWidth(state, data) {
			state.htymlWidth = data
		},
		sethtmlheight(state, data) {
			state.htmlheight = data
		},
		setIsfirst(state, data) {
			state.isfirst = data
		},
		setTableDataTop(state, data) {
			state.tableDataTop = data
		},
		setTableColumnTop(state, data) {
			state.tableColumnTop = data
		},
		setBodyGeneralDesign(state, data) {
			state.bodyGeneralDesign = data
		},

		setBodyTableColumn(state, data) {
			state.bodyTableColumn = data
		},
		setBodyTableData(state, data) {
			state.bodyTableData = data
		},
		setBodyTableColumnAll(state, data) {
			state.bodyTableColumnAll = data
		},
		setBodyTableDataAll(state, data) {
			state.bodyTableDataAll = data
		},

		setchadanfartherData(state, data) {
			state.chadanfartherData = data
		},


		setchadanArr(state, data) { // 查单单头数组
			state.chadanArr = data
		},
		setchadanArrTwo(state, data) { // 查单单体数组
			state.chadanArrTwo = data
		},

		setchadanObj(state, data) { // 查单单头数组
			state.chadanObj = data
		},
		setchadanObjTwo(state, data) { // 查单单体数组
			state.chadanObjTwo = data
		},
		setnaviid(state, data) { // home的导航id
			state.naviid = data
		},
		setpeizhiNaviid(state, data) { // 配置的导航id
			state.peizhiNaviid = data
		},
		setpeizhiType(state, data) { // 配置的类型
			state.peizhiType = data
		},
		setpeizhiName(state, data) { // 配置的类型
			state.peizhiName = data
		},
		setnaviName(state, data) { // 配置的类型
			state.naviname = data
		},
		setcolor(state, data) {
			state.bgcolor = data
		},
		setpeizhiNav(state, data) { // 配置的类型
			state.peizhiNav = data
		},
		sethistoryBB(state, data) {		// 打开过的报表
			state.historyBB = data
		},
	},
	actions: {
		// 提交mutations
		// actions使用dispatch进行触发，就像mutation使用commit触发一样
		onchangLeftWidth(context, data) {
			context.commit('setLeftWidth', data) // 触发mutation
		},
		onchanghtmlWidth(context, data) {
			context.commit('sethtmlWidth', data) // 触发mutation
		},
		onchanghtmlHeight(context, data) {
			context.commit('sethtmlheight', data) // 触发mutation
		},
		onchangColor(context, data) {
			context.commit('setcolor', data) // 触发mutation
		},
		onchangIsfirst(context, data) {
			context.commit('setIsfirst', data) // 触发mutation
		},
		onchangtableDataTop(context, data) {
			context.commit('setTableDataTop', data) // 触发mutation
		},
		onchangtableColumnTop(context, data) {
			context.commit('setTableColumnTop', data)
		},
		onchangBodyGeneralDesign(context, data) {
			context.commit('setBodyGeneralDesign', data)
		},
		onchangBodyTableColumn(context, data) {
			context.commit('setBodyTableColumn', data)
		},
		onchangBodyTableData(context, data) {
			context.commit('setBodyTableData', data)
		},
		onchangBodyTableColumnAll(context, data) {
			context.commit('setBodyTableColumnAll', data)
		},
		onchangBodyTableDataAll(context, data) {
			context.commit('setBodyTableDataAll', data)
		},

		onchangchadanfartherData(context, data) {
			context.commit('setchadanfartherData', data)
		},

		onchangSetchadanArr(context, data) { // 查单单头数组
			context.commit('setchadanArr', data)
		},
		onchangSetchadanArrTwo(context, data) { // 查单单头数组
			context.commit('setchadanArrTwo', data)
		},

		onchangSetchadanObj(context, data) { // 查单单头数组
			context.commit('setchadanObj', data)
		},
		onchangSetchadanObjTwo(context, data) { // 查单单头数组
			context.commit('setchadanArrObj', data)
		},
		onchangSetnaviid(context, data) { // home的导航id
			context.commit('setnaviid', data)
		},
		onchangSetpeizhiNaviid(context, data) { // 配置的导航id
			context.commit('setpeizhiNaviid', data)
		},
		onchangSetpeizhiType(context, data) { // 配置的导航type
			context.commit('setpeizhiType', data)
		},
		onchangSetpeizhiName(context, data) {// 配置的导航name
			context.commit('setpeizhiName', data)
		},
		onchangSetnaviName(context, data) {// 配置的导航name
			context.commit('setnaviName', data)
		},
		onchangSetpeizhiNav(context, data) {// 配置的导航name
			context.commit('setpeizhiNav', data)
		},
		onchangSethistoryBB(context, data) {// 打开过的报表
			context.commit('sethistoryBB', data)
		},
	},
})

export default store


// WEBPACK FOOTER //
// ./src/assets/unit/store.js